import { useCallback } from 'react';
import { applicationPaths } from '@core/http/applicationPaths';
import { useApi } from '@core/http/useApi';
import { UserAccessProfileModel } from '@shared/models';
import { useAppDispatch } from '@core/store/store';
import { accountsReducer } from '@core/store/library-stores/accounts';

export const useUserDetailsDataSource = () => {
  const dispatch = useAppDispatch();

  const [getUserAccessProfile, userAccessProfile, loading, error] = useApi<UserAccessProfileModel>('', 'get');

  const handleGetUserAccessProfile = useCallback(
    (userId: string) => {
      if (!userId) return;

      const url = applicationPaths.users.accessProfile({ userId });
      getUserAccessProfile({ additionalOptions: { url } }).catch(() =>
        dispatch(accountsReducer.slice.actions.setUserRole(null))
      );
    },
    [dispatch, getUserAccessProfile]
  );

  return {
    userAccessProfile,
    getUserAccessProfile: handleGetUserAccessProfile,
    loading,
    error,
  };
};
